import { useInView } from '@cleartax/wg-library-hooks';
import { useRef } from 'react';
import {
  DESKTOP_NAV_SCROLL_OFFSET,
  VERTICAL_SCROLL_OFFSET
} from '../../../../../config/constants';
import * as Navigation from '../../../../../shared/components/layout-components/navigation';
import { SectionProps } from '../../../../../shared/components/layout-components/navigation/types';
import { renderStickyBar } from '../utils';
import { HeroFold } from './hero-fold';

export const PlanDetailsComponent: React.FC<{ sections: SectionProps[] }> = ({
  sections,
}) => {
  const herFoldRef = useRef<HTMLDivElement>(null);
  const isHeroFoldInView = useInView(herFoldRef, {}, true);
  return (
    <div>
      <Navigation.NavigationContainer sections={sections}>
        <Navigation.VerticalAccordian
          scrollOffset={VERTICAL_SCROLL_OFFSET}
          className="sticky z-10 top-20 bg-white xl:hidden lg:hidden md:hidden"
        />
        <div className="wg-container">
          <div ref={herFoldRef}>
            <HeroFold />
          </div>
          <div className="flex ">
            <div className="w-1/4 pr-20 sm:hidden">
              <Navigation.VerticalSideNav
                scrollOffset={DESKTOP_NAV_SCROLL_OFFSET}
                className="sticky top-20"
              />
            </div>
            <Navigation.Content>
              <div className="w-3/4 sm:w-full">{sections}</div>
            </Navigation.Content>
          </div>
        </div>
        {renderStickyBar(herFoldRef, isHeroFoldInView)}
      </Navigation.NavigationContainer>
    </div>
  );
};
